<template>
  <div class="container-fluid">
    <Card>
      <template slot="header">
        <h3>گـــزارش فـروشــ</h3>
        <hr />
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-lg-4 col-12">
            <small id="LblTaskDate"> تاریخ از </small>
            <date-picker input-class="required form-control" color="dimgray" v-model="Data.DateAz" clearable :editable="true" placeholder="تاریخ"></date-picker>
          </div>
          <div class="col-lg-4 col-12">
            <small id="LblTaskDate"> تاریخ تا </small>
            <date-picker input-class="required form-control" color="dimgray" v-model="Data.DateTa" clearable :editable="true" placeholder="تاریخ"></date-picker>
          </div>
          <div class="col-lg-2 col-12">
            <button class="btn btn-success w-100 mt-4" @click="Report(false)">گزارش تفکیکی</button>
          </div>
          <div class="col-lg-2 col-12">
            <button class="btn btn-success w-100 mt-4" @click="Report(true)">گزارش تجمیعی</button>
          </div>
          <div class="col-12 p-2" id="SaleReport">
            <BnpGrid
              v-if="$store.state.renderComponentGrid && IsTajmiei"
              :pagenum="20"
              :SumList="['depositAmout', 'discount', 'totallAmount', 'amountProduct']"
              :action="false"
              :propsColumn="propsColumnTajmi"
              :IsReport="true"
              :HeaderReport="'گزارش  فروش'"
              :ListCommaReport="['depositAmout', 'discount', 'totallAmount', 'amountProduct']"
              :propsRows="propsRows"
              :excel="true"
            >
              <template slot="depositAmout" slot-scope="props">
                {{ $Comma3ragham(props.props.depositAmout) }}
              </template>
              <template slot="discount" slot-scope="props">
                {{ $Comma3ragham(props.props.discount) }}
              </template>
              <template slot="amount" slot-scope="props">
                {{ $Comma3ragham(props.props.amount) }}
              </template>
              <template slot="amountProduct" slot-scope="props">
                {{ $Comma3ragham(props.props.amountProduct) }}
              </template>
            </BnpGrid>
            <BnpGrid
              sortable="true"
              v-if="$store.state.renderComponentGrid && !IsTajmiei"
              :pagenum="10"
              :SumList="['totallAmount', 'amount', 'discount', 'amountProduct']"
              :action="false"
              :IsReport="true"
              :HeaderReport="'گزارش  فروش'"
              :ListCommaReport="['totallAmount', 'amount', 'discount', 'amountProduct']"
              :propsColumn="propsColumnTafkiki"
              :propsRows="propsRows"
              :excel="true"
            >
              <template slot="totallAmount" slot-scope="props">
                {{ $Comma3ragham(props.props.totallAmount) }}
              </template>
              <template slot="amount" slot-scope="props">
                {{ $Comma3ragham(props.props.amount) }}
              </template>
              <template slot="discount" slot-scope="props">
                {{ $Comma3ragham(props.props.discount) }}
              </template>
              <template slot="amountProduct" slot-scope="props">
                {{ $Comma3ragham(props.props.amountProduct) }}
              </template>
            </BnpGrid>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'

export default {
  data() {
    return {
      Data: { DateTa: '', DateAz: '' },
      IsTajmiei: false,
      propsRows: [],
      exceltable: [],
      propsColumnTafkik: [
        { name: 'customerName', label: 'نام مشتری', visibility: true },
        { name: 'name', label: 'نام محصول', visibility: true },
        { name: 'tblContractId', label: 'شماره قرارداد', visibility: true },
        { name: 'dateDeposit', label: 'تاریخ واریز', visibility: true },
        { name: 'amount', label: 'قیمت واحد', visibility: true },
        { name: 'totallAmount', label: 'قیمت با مالیات', visibility: true },
      ],
      propsColumnTajmi: [
        { name: 'customerCode', label: 'کد مشتری', visibility: true },
        { name: 'customerName', label: 'نام مشتری', visibility: true },
        { name: 'tax', label: 'مالیات', visibility: false },
        { name: 'toll', label: 'عوارض', visibility: false },
        { name: 'amount', label: 'قیمت کل بدون تخفیف', visibility: true },
        { name: 'discount', label: 'تخفیف ', visibility: true },
        { name: 'depositAmout', label: 'مبلغ واریز شده', visibility: true },
        { name: 'amountProduct', label: 'قیمت خالص ', visibility: true },
      ],
      propsColumnTafkiki: [
        { name: 'customerCode', label: 'کد مشتری', visibility: true },
        { name: 'customerName', label: 'نام مشتری', visibility: true },
        { name: 'dateDeposit', label: 'تاریخ واریز', visibility: false },
        { name: 'productname', label: 'نام محصول', visibility: true },
        { name: 'tblContractId', label: 'شماره قرارداد', visibility: true },
        { name: 'amount', label: 'مبلغ واریز', visibility: true },
        { name: 'totallAmount', label: 'قیمت کل بدون تخفیف', visibility: true },
        { name: 'discount', label: 'تخفیف ', visibility: true },
        { name: 'amountProduct', label: 'قیمت خالص ', visibility: true },
      ],
    }
  },
  methods: {
    Report(IsTajmi) {
      this.IsTajmiei = IsTajmi
      var DataAxios = { Method: 'POST', Action: '', ArryfildValue: this.Data }
      if (IsTajmi) {
        this.IsTajmiei = true
        DataAxios.Action = 'Reports/SaleTajmie'
      } else {
        this.IsTajmiei = false
        DataAxios.Action = 'Reports/SaleTafkiki'
      }
      this.$PostData(DataAxios)
        .then((result) => {
          if (result.status == 'success') {
            this.propsRows = result.data
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          } else {
            this.$mySweetDefault('عملیات ناموفق', 'لطفا دوباره تلاش کنید', 'warning', 2500)
          }
        })
        .catch((error) => {
          this.$mySweetDefault('خطا', 'در سیستم خطایی رخ داده است.', 'error', 2500)
          console.error('خطا', error)
        })
    },
  },
  computed: {
    SumTotall() {
      var result = 0
      this.propsRows.forEach((e) => {
        result += e.totallAmount
      })
      return result
    },
    SumDiscount() {
      var result = 0
      this.propsRows.forEach((e) => {
        result += e.discount
      })
      return result
    },
    SumToll() {
      var result = 0
      this.propsRows.forEach((e) => {
        result += e.toll
      })
      return result
    },
    SumTax() {
      var result = 0
      this.propsRows.forEach((e) => {
        result += e.tax
      })
      return result
    },
    SumAmount() {
      var result = 0
      this.propsRows.forEach((e) => {
        result += e.amount
      })
      return result
    },
  },
  components: { Card, datePicker: VuePersianDatetimePicker, BnpGrid },
}
</script>
<style scoped>
#SaleReport table > td {
  font-size: small;
}
td {
  text-align: center;
}
</style>
